<template>
  <div id="skip" role="navigation" aria-label="Salta al contingut principal">
    <a href="#maincontent-design" class="skip-link"
      >Salta al contingut principal
    </a>
  </div>
  <Capcalera />
  <div class="container" id="maincontent-design"><router-view /></div>
  <Peu />
</template>

<script>
import Capcalera from "./components/Capcalera";
import Peu from "./components/Peu";

export default {
  components: { Capcalera, Peu },
  setup() {},
};
</script>
<style>
.skip-link {
  position: absolute;
  top: -40px;
  left: 0;
  background: #000;
  color: #fff !important;
  padding: 8px 16px;
  z-index: 1000;
}

.skip-link:focus {
  top: 0;
}
</style>
